<template>
  <el-container class="ym-container">
    <el-header height="56px">
      <el-row type="flex" justify="space-between" style="height: 100%">
        <el-col :span="3" class="ym-header-logo-wrap">
          <div class="ym-header-logo" @click="toggleMenu">
            <img
              class="logo head-logo"
              src="./assets/img/logo.png"
              alt="logo"
              width="137"
              height="24"
              v-if="!isCollapse"
              id="head-logo"
            />
            <img
              v-else
              class="logo-mini"
              src="./assets/img/logo-mini.png"
              alt="logo"
              height="24"
              width="24px"
            />
            <img
              class="logo-mini2"
              src="./assets/img/logo-mini.png"
              alt="logo"
              height="24"
              width="24px"
            />
            <i class="iconfont icon-icon_retract ym-btn-collapse" v-if="!isCollapse"></i>
            <i class="iconfont icon-icon_spread ym-btn-collapse" v-else></i>
          </div>
        </el-col>
        <el-col :span="21" style="text-align: right; min-width: 200px">
          <div class="header-container">
            <el-popover
              placement="bottom-start"
              title=""
              width="200"
              trigger="hover"
              popper-class="follow-popperClass"
              :offset="14"
            >
              <ul id="followList">
                <li v-for="(item, index) in contacts" :key="index" @click="goURl(index)">
                  <img :class="`balance-logo balance-logo${index}`" :src="item.icon"/>
                  <span>{{ item.title }}</span>
                </li>
              </ul>
              <div slot="reference">
                <img
                  :src="require('./assets/img/follow-mobile.png')"
                  class="follow-web-mobile"
                />
                <div class="follow-web">
                  <img
                    :src="require('./assets/img/follow-default.png')"
                    class="img1"
                  />
                  <img
                    :src="require('./assets/img/follow-hover.png')"
                    class="img2"
                  />
                  <span>{{$t('messages.other.other26')}}</span>
                </div>
              </div>
            </el-popover>
            <el-dropdown class="el-dropdown-lang" @command="dropDownLang" popper-class="lang-dropdown-popper">
              <span class="el-dropdown-link2">
                {{ $i18n.locale === 'en' ? 'EN' : 'CN' }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="lang-menu">
                <el-dropdown-item command="en">EN</el-dropdown-item>
                <el-dropdown-item command="zh">CN</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="balance">
              <span class="balance-num">${{ balance ? balance : '0.00' }}</span>
              <img class="balance-logo" src="./assets/img/head-add.png" @click="handleDeposit" />
            </div>
            <div class="info">
              <img
                id="info-logo"
                :class="{ 'info-logo': true, 'hover-now': showInfoList }"
                src="./assets/img/head-notice.svg"
                @mouseenter="handleEnter"
                @touchstart="handleEnter"
              />
              <div class="info-cr" v-if="hasUnreadInfo"></div>
            </div>
            <div class="header-user">
              <el-dropdown :hide-on-click="false">
                <span class="el-dropdown-link">
                  <img class="user-logo" src="./assets/img/head-avatar.png" />
                  <i class="iconfont icon-icon_xia1 mr-1"></i>
                </span>
                <el-dropdown-menu class="user-dropdown" slot="dropdown">
                  <div class="dropdown-item" @click="dropDownRoute('deposit')">
                    <i class="iconfont icon-deposit mr-2"></i>
                    <span class="dropdown-text">{{$t('messages.home.tip63')}}</span>
                  </div>
                  <div class="dropdown-item" @click="dropDownRoute('record')">
                    <i class="iconfont icon-record mr-2"></i>
                    <span class="dropdown-text">{{$t('messages.home.tip62')}}</span>
                  </div>
                  <div class="dropdown-item" @click="dropDownRoute('profile')">
                    <i class="iconfont icon-profile mr-2"></i>
                    <span class="dropdown-text">{{$t('messages.home.tip66')}}</span>
                  </div>
                  <div class="dropdown-item" @click="handleCommand">
                    <i class="iconfont icon-logout mr-2"></i>
                    <span class="dropdown-text">{{$t('messages.other.other27')}}</span>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-header>

    <el-container class="ym-main">
      <el-aside class="ym-main-aside">
        <el-menu
          unique-opened
          :collapse="isCollapse"
          mode="vertical"
          class="ym-menu"
          :default-active="$route.path"
        >
          <div v-for="(item, index) in menus" :key="index">
            <el-submenu :index="index + ''" v-if="!item.u && item.ul.length > 0" :key="index">
              <template slot="title">
                <i class="iconfont" :class="item.i" style="margin-right: 15px;"></i>
                <span slot="title" class="ym-sub-text">{{$t(`messages.menu.${item.lang}`)}}</span>
              </template>
              <el-menu-item
                class="ym-submenu"
                v-for="u in item.ul"
                :index="u.u"
                :key="u.t"
                @click="handleClick"
              >
                <a class="menu-item-a" :href="u.u">{{$t(`messages.menu.${u.lang}`)}}</a>
              </el-menu-item>
            </el-submenu>
            <el-menu-item
              v-if="item.u && item.u === '/snapshot'"
              :index="item.u"
              :key="item.t"
              @click="handleClick"
              class="my-app-menu"
              id="guide-step1"
            >
              <a class="menu-item-a" :href="item.u">
                <img
                  src="./assets/img/rocket.svg"
                  :class="{ 'my-app-menu-img': true, 'my-app-menu-img-clo': isCollapse }"
                />
                <span slot="title" :class="{ 'menu-item-a-span': isCollapse }">{{$t(`messages.menu.${item.lang}`)}}</span>
              </a>
            </el-menu-item>
            <el-menu-item
              @click="handleClick"
              v-if="item.u && item.u !== '/snapshot'"
              :index="item.u"
              :key="item.t"
            >
              <a class="menu-item-a" :href="item.u">
                <i class="iconfont" :class="item.i" style="margin-right: 15px;"></i>
                <span slot="title">{{$t(`messages.menu.${item.lang}`)}}</span>
              </a>
            </el-menu-item>
          </div>
        </el-menu>
      </el-aside>

      <el-main id="elMain">
        <bonusTips v-if="showBonusTips"></bonusTips>
        <div v-if="this.$router.history.current.meta.title === 'Snapshot'">
          <div class="web-titles">
            <p>
              {{ $t('messages.home.tip0') }}{{ $t('messages.home.tip73') }}&nbsp;
              <span>{{ $store.state.profile.username }}{{ $t('messages.home.tip74') }}&nbsp;</span>
              {{ $t('messages.home.tip4') }}
            </p>
            <p>{{ $t('messages.home.tip5') }}</p>
          </div>
          <div class="web-divs">
            <div class="web-divs-item">
              <div class="top">
                <span>{{ $t('messages.home.tip6') }}</span>
              </div>
              <div class="mid">
                <div class="mid-item">
                  <div class="left" @click="jumpUrl('/campaign/list')">{{ $t('messages.home.tip61') }}</div>
                  <div class="right">{{ $t('messages.home.tip8') }}</div>
                </div>
                <div class="mid-item">
                  <div class="left" @click="jumpUrl('/deposit/record')">{{ $t('messages.home.tip62') }}</div>
                  <div class="right">{{ $t('messages.home.tip9') }}</div>
                </div>
                <div class="mid-item">
                  <div class="left" @click="jumpUrl('/deposit')">{{ $t('messages.home.tip63') }}</div>
                  <div class="right">{{ $t('messages.home.tip10') }}</div>
                </div>
              </div>
              <div class="bottom" @click="handleContact">
                {{ $t('messages.home.tip11') }}
              </div>
            </div>
            <div class="web-divs-item">
              <iframe
                :title="$t('messages.other.other35')"
                style="width: 100%; height: 195px;"
                src="https://www.youtube.com/embed/5Gd4bJ0w3m4"
                allowfullscreen
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              ></iframe>
              <div>
                <p>{{ $t('messages.home.tip65') }}</p>
              </div>
              <p></p>
            </div>
            <div class="web-divs-item">
              <div class="top">
                <span>{{ $t('messages.menu.menu8') }}</span>
                <a @click="jumpUrl('/support')">{{ $t('messages.home.tip64') }}</a>
              </div>
              <div class="tips">
                <a @click="jumpUrl('/support')">
                  {{ $t('messages.support.support1') }}
                </a>
                <a @click="jumpUrl('/support')">{{ $t('messages.home.tip13') }}</a>
                <a @click="jumpUrl('/support')">{{ $t('messages.home.tip14') }}</a>
                <a @click="jumpUrl('/support')">{{ $t('messages.home.tip15') }}</a>
                <a @click="jumpUrl('/support')">{{ $t('messages.home.tip16') }}</a>
                <a @click="jumpUrl('/support')">{{ $t('messages.home.tip17') }}</a>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="this.$router.history.current.meta.title === 'Snapshot'"
          class="add-app-wrap"
          id="guide-step2"
        >
          <h1 class="ym-add-title">{{ $t('messages.home.tip7') }}</h1>
          <span class="add-app" @click="addApp" id="add-app" :title="$t('messages.createCampaign.create76')">
            <i class="el-icon-circle-plus add-icon"></i>
          </span>
        </div>
        <h1
          class="ym-title mr-4"
          v-else-if="
            this.$router.history.current.meta.title === 'Create Campaign' &&
              this.$route.query.type &&
              this.$route.query.type === 'detail'
          "
        >
          {{$t('messages.createCampaign.create110')}}
        </h1>
        <h1 class="ym-title mr-4" v-else>
         {{ this.$router.history.current.meta.langkey 
         ? $t(`messages.menu.${this.$router.history.current.meta.langkey}`) 
         : this.$router.history.current.meta.title }}
        </h1>
        <span class="ym-sub-title" v-if="this.$router.history.current.meta.subTitle">
          {{ this.$router.history.current.meta.subTitle }}
        </span>
        <router-view ref="child" @refreshData="refreshData"></router-view>
        <div class="copyright">
          <span>© 2022 有米科技股份有限公司 版权所有</span>
          <span @click="handleDomain">粤ICP备11022409号</span>
          <span @click="handleGo">粤公网安备44011302003751号</span>
        </div>
      </el-main>
    </el-container>
    <el-dialog
      class="guide-confirm"
      :visible.sync="guideVisible"
      width="1008px"
      :close-on-click-modal="false"
    >
      <div class="top">
        <p>
          {{$t('messages.other.other39')}}
          <span>{{$t('messages.other.other40')}}</span>
          {{$t('messages.other.other41')}}
        </p>
      </div>
      <div class="content">
        <div class="contentItem">
          <img class="logo" src="./assets/img/guide-icon1.png" alt="logo" />
          <p class="p1">{{$t('messages.other.other42')}}</p>
        </div>
        <div class="contentItem">
          <img class="logo" src="./assets/img/guide-icon2.png" alt="logo" />
          <p class="p1">{{$t('messages.other.other43')}}</p>
        </div>
        <div class="contentItem">
          <img class="logo" src="./assets/img/guide-icon3.png" alt="logo" />
          <p class="p1">{{$t('messages.other.other44')}}</p>
        </div>
        <div class="contentItem">
          <img class="logo" src="./assets/img/guide-icon4.png" alt="logo" />
          <p class="p1">{{$t('messages.other.other45')}}</p>
        </div>
      </div>
      <div class="footer" slot="footer">
        <div class="footer-wrap">
          <div class="tip-wap">
            <p>{{$t('messages.other.other46')}}</p>
            <span>{{$t('messages.other.other47')}}</span>
            <span>{{$t('messages.other.other48')}}</span>
            <span>{{$t('messages.other.other49')}}</span>
          </div>
          <el-button type="primary" @click="goContact">
            {{$t('messages.tipError.sendErr4')}}
          </el-button>
        </div>
      </div>
    </el-dialog>
    <img
      class="gift-box"
      src="./assets/img/gift.gif"
      alt="logo"
      @click="showGuide"
      v-if="first_top_up === 1"
    />
    <!-- <contact-box :recharged="first_top_up" :langChange="false"></contact-box> -->
    <div class="back-top" @click="backTop" v-if="showBackTop">
      <img src="./assets/img/back-top.png" alt="backtop" class="backtop1" />
      <img src="./assets/img/back-top-hover.png" alt="backtop" class="backtop2" />
    </div>

    <div :class="{ 'info-wrap': true, 'no-info-wrap': noInfo }" v-if="showInfoList">
      <div class="info-tab">
        <div
          @click="e => handleTab(e, index)"
          :class="{ tabItem: true, active: tabIndex === index }"
          v-for="(item, index) in infoType"
          :key="index"
        >
          <p>{{$t(`messages.home.${infoTypeLang[index]}`)}}</p>
          <div v-if="message_all_read[listType[index]] === 0"></div>
        </div>
      </div>
      <div class="info-content">
        <template v-if="!noInfo">
          <div class="content-list">
            <div
              :class="{ 'list-item': true, listActive: listIndex === index }"
              v-for="(item, index) in list[listType[tabIndex]]"
              :key="item.id"
              @click="e => handleListTab(e, item, index)"
            >
              <div class="item-head">
                <div class="item-head-img">
                  <img
                    class="item-head-logo"
                    :src="require(`./assets/img/act1.png`)"
                    v-if="index === listIndex && tabIndex === 0"
                  />
                  <img
                    class="item-head-logo"
                    :src="require(`./assets/img/act2.png`)"
                    v-if="index === listIndex && tabIndex === 1"
                  />
                  <img
                    class="item-head-logo"
                    :src="require(`./assets/img/act3.png`)"
                    v-if="index === listIndex && tabIndex === 2"
                  />
                  <img
                    class="item-head-logo"
                    :src="require(`./assets/img/def1.png`)"
                    v-if="index !== listIndex && tabIndex === 0"
                  />
                  <img
                    class="item-head-logo"
                    :src="require(`./assets/img/def2.png`)"
                    v-if="index !== listIndex && tabIndex === 1"
                  />
                  <img
                    class="item-head-logo"
                    :src="require(`./assets/img/def3.png`)"
                    v-if="index !== listIndex && tabIndex === 2"
                  />
                  <div class="head-logo-cr" v-if="item.read === 0"></div>
                </div>

                <p class="item-head-tit oneline" :title="item.title">{{ item.title }}</p>
                <p class="item-head-time">{{ item.time_str }}</p>
              </div>
              <div class="item-desc moreline" v-html="item.content"></div>
              <!-- <text-line></text-line> -->
              <div class="content-banner-mobile">
                <img :src="item.content_banner" v-if="item.content_banner" />
              </div>
              <div class="content-btn">
                <el-button
                  type="primary"
                  class="content-btn-p"
                  @click="e => handleViewDetail(e, info.button_link)"
                >
                  {{ info.button_name }}
                </el-button>
              </div>
            </div>
          </div>
          <div class="content-detail">
            <p class="content-tit">{{ info.title }}</p>
            <img class="content-img" :src="info.content_banner" v-if="info.content_banner" />
            <p class="content-sub-tit" v-html="info.content"></p>
            <div class="content-btn">
              <el-button
                type="primary"
                class="content-btn-p"
                @click="e => handleViewDetail(e, info.button_link)"
              >
                {{ info.button_name }}
              </el-button>
            </div>
            <div class="content-bot">
              <p @click="handleListIndex(0)" v-if="listIndex !== 0">Preview</p>
              <p
                @click="handleListIndex(1)"
                class="content-bot-p"
                v-if="listIndex !== list[listType[tabIndex]].length - 1"
              >
                {{$t('messages.login.next')}}
              </p>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="no-info">
            <p>{{$t('messages.login.ninfo')}}</p>
          </div>
        </template>
      </div>
    </div>

    <div
      class="info-tip-wrap"
      v-for="(item, index) in $store.state.message.data"
      :style="{ top: 70 + index * 176 + 'px' }"
      :key="item.id"
    >
      <div class="tip-top">
        <div class="tip-top-left">
          <i class="iconfont icon-info mr-1 tip-logo"></i>
          <p>{{ item.title }}</p>
        </div>
        <div class="tip-top-right">
          <div @click="e => handleClose(e, index)">
            <img src="./assets/img/icon-clo.png" alt="logo" height="16" />
          </div>
        </div>
      </div>
      <p class="tip-content moreline" v-html="item.content"></p>
      <div class="tip-btn">
        <div class="btn-ok" @click="e => handleRead(e, item, index, 0)">{{$t('messages.home.tip75')}}</div>
        <div class="btn-view" @click="e => handleRead(e, item, index, 1)">{{$t('messages.home.tip3')}}</div>
      </div>
    </div>

    <div class="thank-give">
      <img
        src="./assets/img/shengdantree.png"
        @click="showTree = false"
        class="img2"
        v-if="showTree"
      />
      <img src="./assets/img/thank-login-logo.png" @click="showTree = true" class="img1" v-else />
    </div>
    <!-- width="600px" changePop -->
    <el-dialog
      :visible.sync="$store.state.popVisible2"
      width="600px"
      class="pay-list2-action"
      :close-on-click-modal="false"
    >
      <div class="pay-list2-body" @click="handleThankDetail" id="pay-list2-body"></div>
      <div class="pay-list2-icon">
        <i class="iconfont icon-circle-close" @click="closePop"></i>
      </div>
    </el-dialog>

    <!-- 填写注册信息 -->
    <el-dialog
      :visible.sync="$store.state.profile.need_fill"
      width="640px"
      :close-on-click-modal="false"
      :show-close = "false"
      class="register-dialog"
    >
      <register-form
        @changeDialog="changeDialog"
        ref="registerFormRef"
        @getProfile="getProfile"
      ></register-form>
    </el-dialog>

    <el-dialog :visible.sync="noAppDialog" width="560px" :close-on-click-modal="false">
      <div class="noAppDialog">
        <p>{{$t('messages.createCampaign.create162')}}</p>
        <p>{{$t('messages.createCampaign.create163')}}</p>
        <div class="btns">
          <el-button class="btn1" @click="postSigup(false)">{{$t('messages.createCampaign.create161')}}</el-button>
          <el-button class="btn2" @click="changeDialog(false)">{{$t('messages.createCampaign.create109')}}</el-button>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import bonusTips from './components/bonusTips'
import registerForm from './components/registerForm.vue'
import { throttle, debounce } from 'lodash'
// 引入自己封装的新手引导函数
import { guide, hideGuide } from '@/js/intro'
import { mapState, mapGetters } from 'vuex'
export default {
  components: {
    bonusTips,
    registerForm,
  },
  data() {
    return {
      showTree: false,
      tabIndex: 0,
      showInfoList: false,
      menus: [
        {
          i: 'icon-dashboard',
          t: 'Grow My Apps',
          u: '/snapshot',
          lang: 'menu1'
        },
        {
          i: 'icon-campaign',
          t: 'Campaign',
          lang: 'menu2',
          ul: [
            {
              t: 'Create Campaign',
              u: '/campaign/create',
              lang: 'menu3',
            },
            {
              t: 'My Campaign',
              u: '/campaign/list',
              lang: 'menu4',
            },
            {
              t: 'Top-ranking Task',
              u: '/campaign/create-brush',
              lang: 'menu10',
            },
            {
              t: 'My Top-ranking Task',
              u: '/campaign/brush-list',
              lang: 'menu11',
            },
          ],
        },
        {
          i: 'icon-deposit',
          t: 'Deposit',
          lang: 'menu5',
          ul: [
            {
              t: 'Deposit',
              u: '/deposit',
              lang: 'menu5',
            },
            {
              t: 'Record',
              u: '/deposit/record',
              lang: 'menu6',
            },
          ],
        },
        {
          i: 'icon-profile',
          t: 'Account',
          u: '/profile',
          lang: 'menu7',
        },
        {
          i: 'icon-bangzhu',
          t: 'FAQ',
          u: '/support',
          lang: 'menu8',
        },
      ],
      isCollapse: false,
      showEventTips: true,
      showBonusTips: true,
      profile: {
        email: '',
        // campaign_new_user:0,// 1 没有创建过，0 创建过
      },
      balance: '',
      leavePath: '',
      guideVisible: false,
      infoType: ['Campaign', 'Balance', 'Notification'],
      infoTypeLang: ['tip61', 'tip70', 'tip71'],
      listIndex: 0,
      noInfo: true,
      info: {
        // 当前列表选中的信息
        id: '',
        title: '',
        content: '',
        time_str: '',
        button_link: '',
        button_name: '',
        read: 1, // 消息是否已读，1为已读，0为否
        content_banner: '',
      },
      listType: ['campaign', 'balance', 'activity'],
      list: {
        campaign: [],
        balance: [],
        activity: [],
      },
      message_all_read: {
        // 给类型消息全部已读状态，campaign，balance，activity。1为已读，0为否
        campaign: 1,
        balance: 1,
        activity: 1,
      },
      first_top_up: 0,
      thankExpand: true,
      showBackTop: false,
      contacts: [
        {
          icon: require('./assets/img/lvwhats.png'),
          title: 'WhatsApp',
          link: 'https://wa.me/8618028539642',
        },
        {
          icon: require('./assets/img/lanteams.png'),
          title: 'Teams',
          link: 'https://teams.live.com/l/invite/FEAOtIKX0rDmnGUuwE',
        },
        {
          icon: require('./assets/img/contact-linkedin.svg'),
          title: 'LinkedIn',
          link: 'https://www.linkedin.com/company/asogrow',
        },
      ],
      noAppDialog: false,
    }
  },
  computed: {
    hasUnreadInfo() {
      let obj = this.message_all_read
      return obj.campaign === 0 || obj.balance === 0 || obj.activity === 0
    },
    ...mapState(['holiday']),
    ...mapGetters(['holidayNow']),
  },
  watch: {
    $route: {
      handler: function() {
        if (this.$route.meta.title === 'Snapshot') {
          this.showEventTips = false
          // this.handleGuide()
        } else {
          this.showEventTips = true
        }
        if (this.$route.meta.title === 'Deposit') {
          this.showBonusTips = false
        } else {
          this.showBonusTips = true
        }
      },
      // 深度观察监听
      immediate: true,
    },
    '$store.state.introStepInfo.currentStep': {
      handler(newVal, oldVal) {
        if (parseInt(sessionStorage.getItem('complete_guide'))) return
        if (newVal === 1 && (!oldVal || oldVal === 2)) {
          this.handleGuide(1)
        }
        if (newVal === 2 && this.$route.meta.title === 'Snapshot') {
          this.handleGuide(2)
        }
      },
      deep: true,
      immediate: true,
    },
    '$store.state.popVisible2': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$nextTick(() => {
          })
        } else {
          // console.log('不显示pop');
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.getProfile()
    this.$store.dispatch('getHoliday')
    this.getBalance()
    this.isAdBlock().then(v => {
      if (v) {
        this.notifyOpen(
          'Error',
          this.$t('messages.createCampaign.create152'),
          'error'
        )
      }
    })
    if (document.documentElement.clientWidth < 1120) {
      this.isCollapse = true
    }

    window.addEventListener('resize', debounce(this.handleResize, 50))
    document.addEventListener('mousedown', e => {
      let isSelf = document.getElementsByClassName('info-wrap')[0]
      let isSelfAside = document.getElementsByClassName('ym-main-aside')[0] // 最外层元素
      let isSelfLogo = document.getElementsByClassName('ym-header-logo')[0] // 最外层元素
      if (isSelf) {
        let flag = isSelf.contains(e.target)
        if (!flag) {
          this.showInfoList = false
        }
      }
      let flag1, flag2
      if (isSelfAside) {
        flag1 = isSelfAside.contains(e.target)
      }
      if (isSelfLogo) {
        flag2 = isSelfLogo.contains(e.target)
      }
      let docDomWitdh = document.documentElement.clientWidth || document.body.clientWidth
      if (!flag1 && !flag2 && docDomWitdh < 530) {
        this.isCollapse = true
      }
    })
    setTimeout(() => {
      this.getAllInfo()
    }, 0)
    this.timer = window.setInterval(() => {
      this.getAllInfo()
    }, 30000)
    if (this.$route.meta.title === 'Snapshot') {
      this.showEventTips = false
    } else {
      this.showEventTips = true
    }
    if (this.$route.meta.title === 'Deposit') {
      this.showBonusTips = false
    } else {
      this.showBonusTips = true
    }
  },
  mounted() {
    var elements = document.getElementsByClassName('menu-item-a')
    Array.prototype.forEach.call(elements, function(element) {
      element.addEventListener(
        'click',
        function(e) {
          e.preventDefault()
        },
        false
      )
    })
    let dom = document.getElementById('elMain')
    if (dom) {
      dom.addEventListener('scroll', this.handleScroll)
    }
  },
  destroyed() {
    window.clearInterval(this.timer)
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    dropDownLang(lang){
      if(lang === this.$i18n.locale) return;
      this.$i18n.locale = lang
    },
    handleContact() {
      // this.$EventBus.$emit('showContact')
      let href = 'https://wa.me/8618028539642'
      window.open(href, '_blank')
    },
    jumpUrl(url) {
      this.$router.push(url)
    },
    postSigup() {
      this.noAppDialog = false
      this.$refs.registerFormRef.signUpPost()
    },
    changeDialog(status) {
      this.noAppDialog = status
    },
    goURl(index) {
      let { link } = this.contacts[index]
      window.open(link, '_blank')
    },
    closePop() {
      this.$store.commit('UPDATE_POP', false)
    },
    handleResize() {
      let _this = this
      let width = document.body.clientWidth || document.documentElement.clientWidth
      this.showMobile = width < 1025
      if (width < 1120) {
        _this.isCollapse = true
      }
      if (width < 1025) {
        hideGuide()
      }
    },
    handleGuide(step) {
      this.$nextTick(() => {
        if (step === 1) {
          guide([
            {
              title: this.$t('messages.home.tip18'),
              intro: `${this.$t('messages.guide.guide1')}(1/7)`,
              element: document.querySelector('#guide-step1'),
            },
          ])
        } else if (step === 2) {
          guide([
            {
              title: this.$t('messages.home.tip18'),
              intro: `${this.$t('messages.guide.guide1')}(2/7)`,
              element: document.querySelector('#guide-step2'),
            },
          ])
        }
      })
    },
    handleScroll() {
      let dom = document.getElementById('elMain')
      if (dom) {
        let top = dom.scrollTop
        if (top > 100) {
          this.showBackTop = true
        } else {
          this.showBackTop = false
        }
      }
    },
    backTop() {
      let dom = document.getElementById('elMain')
      let top = dom.scrollTop
      const timeTop = setInterval(() => {
        dom.scrollTop = top -= 50
        if (top <= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    },
    handleThankDetail() {
      this.$store.commit('UPDATE_POP', false)
      this.$router.push({ path: '/deposit', query: { type: 'thank' } })
      this.$EventBus.$emit('scrollThank')
    },
    handleThankExpand(status) {
      this.thankExpand = status
    },
    addApp() {
      this.$EventBus.$emit('handleAddApp')
    },
    handleDomain() {
      window.open('https://beian.miit.gov.cn', '_blank')
    },
    handleGo() {
      window.open(
        'https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011302003751',
        '_blank'
      )
    },
    handleDeposit() {
      this.$router.replace('/deposit')
    },
    handleViewDetail(e, link, type) {
      let arr = ['https://', 'http://']
      if (link.indexOf(arr[0]) > -1 || link.indexOf(arr[1]) > -1) {
        window.open(link, '_blank')
      } else {
        this.$router.push(link)
      }
    },
    handleEnter: throttle(function() {
      this.tabIndex = 0
      this.listIndex = 0
      this.getAllInfo('enter')
    }, 300),
    getAllInfo(type) {
      this.$http.get('/api/messages/').then(data => {
        if (type === 'enter') {
          this.showInfoList = true
        }
        if (this.showInfoList) {
          this.list['campaign'] = data.data.campaign
          this.list['balance'] = data.data.balance
          this.list['activity'] = data.data.activity
          if (data.data[this.listType[this.tabIndex]].length === 0) {
            this.noInfo = true
          } else {
            this.noInfo = false
            this.info = this.list[this.listType[this.tabIndex]][this.listIndex]
            if (this.info.read === 0) {
              this.readInfo(this.info)
            }
          }
        }
        this.message_all_read = data.data.read_status
      })
    },
    handleTab(e, index) {
      if (this.tabIndex === index) return
      this.tabIndex = index
      if (this.list[this.listType[index]].length === 0) {
        this.noInfo = true
      } else {
        this.noInfo = false
        this.listIndex = 0
        this.info = this.list[this.listType[index]][0]
        if (this.info.read === 0) {
          this.readInfo(this.info)
        }
      }
    },
    handleClose(e, i) {
      this.$store.commit('RESET_MESSAGE', i)
    },
    handleRead(e, row, i, typeAct) {
      this.$http.get(`/api/messages/read/?id=${row.id}`).then(data => {
        this.$store.commit('RESET_MESSAGE', i)
      })
      if (typeAct === 1) {
        this.handleEnter()
      }
    },
    handleListIndex(type) {
      let i = type === 0 ? this.listIndex - 1 : this.listIndex + 1
      this.handleListTab(undefined, this.info, i)
      let dom = document.getElementsByClassName('content-list')[0]
      if (type === 0) {
        dom.scrollTop -= 107
      } else {
        dom.scrollTop += 107
      }
    },
    handleListTab(e, row, index) {
      if (this.listIndex === index) return
      this.listIndex = index
      let type = this.listType[this.tabIndex]
      this.info = this.list[type][index]
      if (this.info.read === 0) {
        this.readInfo(row)
      }
    },
    readInfo(row) {
      this.$http.get(`/api/messages/read/?id=${row.id}`).then(data => {
        this.info.read = 1
        let type = this.listType[this.tabIndex]
        this.message_all_read[type] = data.data.message_all_read
      })
    },
    refreshData() {
      this.getProfile()
      this.getBalance()
    },
    handleClick(e) {
      this.$router.push(e.index)
    },
    showGuide() {
      this.guideVisible = true
      if (process.env.NODE_ENV === 'production' && window.gtag) {
        window.gtag('event', 'click_guide', { event_category: 'btnClick' })
      }
    },
    goContact() {
      this.guideVisible = false
      this.$EventBus.$emit('showContact')
      this.OpenTawkChat()
      // this.$router.push('/campaign/create')
      if (process.env.NODE_ENV === 'production' && window.gtag) {
        window.gtag('event', 'click_pop_guide', { event_category: 'btnClick' })
      }
    },
    getProfile() {
      this.$http.get('/api/accounts/profile/').then(data => {
        this.profile = data
        this.first_top_up = data.first_top_up
        this.$store.commit('PROFILE', data)
        if (!data.need_fill) {
          if (data.complete_guide === 0) {
            this.$store.state.introStepInfo.currentStep = 1
            sessionStorage.setItem('currentStep', 1)
          } else {
            this.$store.commit('UPDATE_POP', this.holidayNow) // changePop Status
          }
          this.$store.state.introStepInfo.complete_guide = data.complete_guide
          sessionStorage.setItem('complete_guide', data.complete_guide)
        }
      })
    },
    getBalance() {
      this.$http.get('/api/campaign/total_info/').then(data => {
        let balance = (Math.round(data.data.balance * 100) / 100).toFixed(2)
        this.balance = balance
      })
    },
    handleCommand() {
      this.Logout()
    },
    toggleMenu() {
      this.isCollapse = !this.isCollapse
    },
    dropDownRoute(pageName) {
      this.$router.push({ name: pageName })
    },
  },
}
</script>

<style lang="scss">
.lang-dropdown-popper {
  margin-top: 12px !important;
}
.follow-popperClass {
  // display: block !important;
  // position: absolute;
  // left: 882px;

  top: 50px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
  width: 180px !important;
  ul {
    list-style: none;
    padding-left: 0;
    margin: 0;
    li {
      display: flex;
      align-items: center;
      padding: 6px 12px;
      cursor: pointer;
      > img {
        width: 24px;
        height: 24px;
        margin-right: 4px;
        flex-shrink: 0;
        display: block;
      }
      .balance-logo0 {
        width: 24px;
        height: 24px;
        margin-right: 4px;
      }
      > span {
        font-size: 14px;
        color: #303133;
        height: 20px;
        display: inline-block;
        line-height: 20px;
      }
      &:hover {
        background: #f5f7fa;
        > span {
          color: #1861f2;
        }
      }
    }
  }
}
.introjs-button {
  padding: 4px 8px !important;
  color: #1861f2 !important;
  background-color: #fff !important;
}
.introjs-button:hover {
  background-color: #f4f4f4;
}

.introjs-button:focus {
  box-shadow: none;
}
.introjs-skipbutton {
  font-size: 14px;
}

.introjs-helperLayer {
  box-shadow: rgba(33, 33, 33, 0.8) 0px 0px 0px 0px, rgba(33, 33, 33, 0.5) 0px 0px 0px 5000px !important;
}

.introjs-tooltip {
  background-color: #1861f2;
  color: #fff;
}

.introjs-skipbutton {
  color: rgba(255, 255, 255, 0.5);
  &:hover {
    color: #fff;
  }
}

.introjs-tooltipbuttons {
  border-top: none;
}

.introjs-tooltip-header {
  padding-left: 16px;
  padding-right: 16px;
}

.introjs-tooltiptext {
  padding: 10px 16px;
  line-height: 18px;
}
.introjs-arrow.top {
  border-bottom-color: #1861f2;
}
.introjs-arrow.bottom {
  border-top-color: #1861f2;
}
.introjs-arrow.right {
  border-right-color: #1861f2;
}
.introjs-arrow.left {
  border-left-color: #1861f2;
}
</style>
<style lang="scss">
@keyframes bounceInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, 0px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 15px, 0);
  }
  // 75% {
  //   // transform: translate3d(0,-15px,0);
  //   transform: translate3d(0,15px,0);
  // }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  100% {
    transform: translateZ(0);
  }
}

.noAppDialog {
  padding: 20px 20px 10px;
  > p {
    font-weight: 600;
    font-size: 20px;
    color: #303133;
    text-align: left;
    margin-bottom: 14px;
  }
  .btns {
    display: flex;
    flex-direction: column;
    .el-button {
      margin-left: 0;
      padding: 12px;
      margin-top: 20px;
    }
    .btn1 {
      background: #1861f2;
      color: #fff;
    }
  }
}
.pc-confirm {
  z-index: 2010;
  .el-dialog {
    width: 76%;
    margin-top: 170px;
    .el-dialog__body {
      word-break: break-word;
    }
  }
}

.thank-give {
  position: fixed;
  right: 20px;
  top: 60px;
  z-index: 1000;
  display: none;
  .img1 {
    width: 272px;
    height: 152px;
  }
  .img2 {
    width: 70px;
    height: 70px;
  }
  > img {
    cursor: pointer;
  }
}
.info-wrap {
  animation: bounceInDown 0.2s cubic-bezier(0.215, 0.61, 0.355, 1) 0.2s both;
  position: fixed;
  right: 38px;
  top: 62px;
  width: 578px;
  min-height: 381px;
  background: #ffffff;
  box-shadow: 0px 6px 12px 0px rgba(33, 35, 41, 0.1);
  border-radius: 4px;
  opacity: 1;
  border: 1px solid #ebeef5;
  z-index: 1001;
  display: flex;
  flex-direction: column;

  .info-tab {
    display: flex;
    height: 38px;
    padding-left: 16px;
    padding-top: 20px;
    align-items: end;
    border-bottom: 1px solid #ebeef5;
    .tabItem {
      margin-right: 24px;
      position: relative;
      cursor: pointer;
      border-bottom: 2px solid #fff;
      padding-bottom: 6px;
      > p {
        height: 22px;
        font-size: 14px;
        font-weight: 400;
        color: #303133;
        line-height: 22px;
      }
      > div {
        width: 8px;
        height: 8px;
        background: #f65d5d;
        border-radius: 50%;
        position: absolute;
        right: -4px;
        top: 0px;
      }
    }
    .tabItem.active {
      border-bottom: 2px solid #1861f2;
      > p {
        color: #1861f2;
      }
    }
  }
  .info-content {
    flex: 1;
    display: flex;
    padding-top: 10px;
    padding-bottom: 12px;
    .content-list {
      width: 280px;
      max-height: 320px;
      overflow: auto;
      overflow-x: hidden;
      .list-item {
        padding: 8px 16px;
        border-bottom: 1px solid #ebeef5;
        cursor: pointer;
        &:last-child {
          border-bottom: 0;
        }
        .item-head {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          .item-head-img {
            position: relative;
          }
          .item-head-logo {
            width: 24px;
            height: 24px;
            margin-right: 8px;
          }
          .head-logo-cr {
            width: 8px;
            height: 8px;
            background: #f65d5d;
            border-radius: 50%;
            right: 6px;
            top: -2px;
            position: absolute;
          }
          .item-head-tit {
            font-size: 14px;
            font-weight: 400;
            color: #303133;
            line-height: 22px;
            width: 54%;
          }
          .item-head-time {
            font-size: 12px;
            font-weight: 400;
            color: #c0c4cc;
            line-height: 20px;
            margin-left: 8px;
          }
        }
        .item-desc {
          font-size: 14px;
          font-weight: 400;
          color: #606266;
          line-height: 22px;
        }
        .content-btn {
          justify-content: flex-end;
          margin-bottom: 16px;
          margin-top: 16px;
          display: none;
          .content-btn-p {
            border-radius: 4px;
            height: 32px;
          }
        }
        .content-banner-mobile {
          display: none;
        }
      }
      .listActive {
        background: #f5f7fa;
      }
    }
    .content-detail {
      flex: 1;
      background: #f5f7fa;
      padding: 16px;
      max-height: 288px;
      overflow: auto;
      overflow-x: hidden;
      .content-tit {
        font-size: 16px;
        font-weight: 500;
        color: #303133;
        line-height: 24px;
        margin-bottom: 8px;
      }
      .content-img {
        width: 240px;
        height: 120px;
      }
      .content-sub-tit {
        font-size: 14px;
        font-weight: 400;
        color: #606266;
        margin-bottom: 18px;
        line-height: 22px;
      }
      .content-btn {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 16px;
        .content-btn-p {
          border-radius: 4px;
          height: 32px;
        }
      }
      .content-bot {
        font-size: 12px;
        display: flex;
        justify-content: end;
        > p {
          font-weight: 400;
          color: #c0c4cc;
          line-height: 20px;
          cursor: pointer;
          font-size: 14px;
        }
        .content-bot-p {
          margin-left: 16px;
        }
        > p:hover {
          color: #6666ff;
        }
      }
    }
    .no-info {
      margin-top: 104px;
      width: 100%;
      > p {
        font-size: 14px;
        font-weight: 400;
        color: #909399;
        line-height: 22px;
        text-align: center;
      }
    }
  }
}
.no-info-wrap {
  width: 271px;
  height: 280px;
}
.info-tip-wrap {
  position: fixed;
  right: 40px;
  width: 360px;
  background: #ffffff;
  box-shadow: 0px 6px 12px 0px rgba(33, 35, 41, 0.1);
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #ebeef5;
  padding: 16px 16px 12px;
  z-index: 1001;
  .tip-top {
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
    .tip-top-left {
      display: flex;
      align-items: center;
      .tip-logo {
        color: #3399ff;
      }
      > img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
      > p {
        font-size: 16px;
        font-weight: 400;
        color: #303133;
        line-height: 24px;
        flex: 1;
      }
    }
    .tip-top-right {
      > div {
        color: #d0d3d9;
        width: 12px;
        height: 8px;
        cursor: pointer;
      }
    }
  }
  .tip-content {
    font-size: 14px;
    font-weight: 400;
    color: #606266;
    margin-bottom: 16px;
    line-height: 22px;
    height: 44px;
    padding: 0 21px;
    a {
      padding: 0;
    }
  }
  .tip-btn {
    display: flex;
    justify-content: end;
    .btn-ok,
    .btn-view {
      border-radius: 4px;
      height: 28px;
      opacity: 1;
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .btn-ok {
      width: 64px;
      background: #ffffff;
      border: 1px solid rgba(24, 97, 242, 0.75);
      color: #1861f2;
    }
    .btn-view {
      padding: 0 10px;
      background: #1861f2;
      color: #ffffff;
      margin-left: 8px;
    }
  }
}
.oneline {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.moreline {
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.guide-confirm {
  .el-dialog__body {
    padding-left: 48px;
    padding-right: 48px;
    padding-top: 30px;
  }
  .top {
    margin-bottom: 32px;
    > p {
      height: 28px;
      font-size: 24px;
      font-weight: bold;
      color: #303133;
      line-height: 28px;
      text-align: center;
      > span {
        color: #3776f4;
      }
    }
  }
  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .contentItem {
      width: 220px;
      display: flex;
      flex-direction: column;
      align-items: center;
      > img {
        width: 200px;
        height: 120px;
        margin-bottom: 16px;
      }
      > p {
        font-weight: 400;
        text-align: center;
      }
      .p1 {
        height: 22px;
        font-size: 14px;
        color: #303135;
        line-height: 22px;
        margin-bottom: 8px;
        font-weight: bold;
      }
      .p2 {
        height: 80px;
        font-size: 12px;
        color: #606266;
        line-height: 20px;
      }
    }
  }
  .footer {
    padding-bottom: 20px;
    .el-button--primary {
      width: 360px;
      height: 48px;
      border-radius: 8px 8px 8px 8px;
      font-size: 18px;
      font-weight: 400;
    }
    .footer-wrap {
      display: flex;
      justify-content: space-around;
      align-items: flex-end;
      .tip-wap {
        font-size: 16px;
        > p {
          text-align: left;
          margin-bottom: 14px;
          font-weight: 500;
          color: #303133;
          border-left: 3px solid #1861f2;
          padding: 4px 8px;
        }
        > span {
          color: #1861f2;
          display: block;
          text-align: left;
          margin-bottom: 4px;
        }
      }
    }
  }
}
.gift-box {
  width: 72px;
  height: 72px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  cursor: pointer;
}

.leave-confirm {
  .tip {
    font-size: 24px;
    font-weight: 500;
    color: #303133;
    text-align: center;
    margin-bottom: 16px;
    > span {
      color: #f76a6a;
    }
  }
  .tip2 {
    font-size: 16px;
    font-weight: 400;
    color: #faab35;
    line-height: 24px;
    text-align: center;
  }
  .footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .el-dialog__footer {
      padding-top: 0;
      padding-bottom: 43px;
    }
    .el-button--primary {
      border-radius: 4px;
    }
    > p {
      font-size: 14px;
      font-weight: 400;
      color: #909399;
      margin-top: 16px;
      cursor: pointer;
    }
  }
  .el-result {
    padding: 0;
  }
}

.center {
  text-align: center;
}

.ym-container.el-container {
  height: 100%;
  background-color: #f6f8fb;
  .back-top {
    width: 48px;
    height: 48px;
    background: #ffffff;
    cursor: pointer;
    border: 1px solid #ebeef5;
    position: fixed;
    bottom: 20px;
    right: 41px;
    z-index: 1000;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    > img {
      width: 17px;
      height: 23px;
    }
    .backtop2 {
      display: none;
    }
    &:hover {
      background: #1861f2;
      border: none;
      .backtop1 {
        display: none;
      }
      .backtop2 {
        display: block !important;
      }
    }
  }
  .collapse {
    margin-left: -100px;
    transition: all 0.1s;
  }
  & > .el-header {
    padding: 10px 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px 0px rgba(36, 117, 164, 0.08);
    .line-bl {
      display: inline-block;
    }
    .ym-header-logo-wrap {
      min-width: 225px;
    }
    .ym-header-logo {
      text-align: left;
      line-height: 36px;
      .logo {
        vertical-align: middle;
        cursor: pointer;
      }
      .logo-mini,
      .logo-mini2 {
        vertical-align: middle;
        cursor: pointer;
      }
      .logo-mini2 {
        display: none;
      }
    }
    .ym-btn-collapse {
      margin-left: 18px;
      font-size: 22px;
      cursor: pointer;
      color: #d0d3d9;
      vertical-align: middle;
    }
  }
  .header-container {
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .faq {
      line-height: 36px;
      margin-right: 24px;
      cursor: pointer;
      .iconfont {
        font-size: 22px;
        color: #d0d3d9;
        vertical-align: middle;
      }
      .faq-text {
        vertical-align: middle;
        color: #6b6d71;
        font-size: 14px;
      }
    }
    .balance {
      display: flex;
      align-items: center;
      border-radius: 16px;
      opacity: 1;
      border: 1px solid #e1e4eb;
      padding: 0 8px;
      margin-right: 24px;
      height: 100%;
      min-width: 90px;
      justify-content: center;
      .balance-num {
        vertical-align: middle;
        color: #1861f2;
        font-size: 14px;
      }
      .balance-logo {
        width: 28px;
        height: 28px;
        margin-left: 4px;
        cursor: pointer;
      }
    }
    .info {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-right: 24px;
      overflow: hidden;
      .info-logo {
        width: 24px;
        height: 24px;
      }
      .info-cr {
        width: 8px;
        height: 8px;
        background: #f65d5d;
        border-radius: 50%;
        position: absolute;
        right: 2px;
        top: 0;
      }
    }

    .info-logo:hover {
      transform: translateX(-100px);
      filter: drop-shadow(#1861f2 100px 0);
    }
    .hover-now {
      transform: translateX(-100px);
      filter: drop-shadow(#1861f2 100px 0);
    }
    .header-user {
      line-height: 36px;
      cursor: pointer;
      .user-logo {
        width: 24px;
        height: 24px;
        vertical-align: middle;
      }
      .el-dropdown-link {
        .iconfont {
          font-size: 22px;
          color: #d0d3d9;
          vertical-align: middle;
        }
      }
    }
    .el-dropdown-lang{
      .el-dropdown-link2 {
        cursor: pointer;
        color: #409EFF;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 60px;
        margin: 0 auto;
      }
      .el-icon-arrow-down {
        font-size: 12px;
        color: #409EFF;
      }
    }

    .follow-web {
      cursor: pointer;
      background: rgba(227, 0, 119, 0.1);
      border-radius: 27px;
      display: flex;
      align-items: center;
      padding: 6px 12px 6px 8px;
      color: #e30077;
      font-weight: 400;
      > img {
        width: 24px;
        margin-right: 4px;
      }
      .img2 {
        display: none;
      }
      &:hover {
        background: linear-gradient(180deg, #ff9ecf 0%, #ed0c7c 100%);
        color: #ffffff;
        .img2 {
          display: inline-block;
        }
        .img1 {
          display: none;
        }
      }
    }
    .follow-web-mobile {
      display: none;
      cursor: pointer;
      width: 24px;
    }
  }
  .ym-main {
    min-height: 100%;
    .menu-item-a {
      display: block;
      text-decoration: none;
      color: #6b6d71;
      padding: 0;
      overflow: hidden;
      .menu-item-a-span {
        display: none;
      }
      .my-app-menu-img-clo {
        padding-left: 6px;
      }
    }
    .menu-item-a:hover {
      text-decoration: none;
    }
    .el-aside {
      width: auto !important;
      margin-top: 2px;
      box-shadow: 4px 0px 8px 0px rgba(36, 117, 164, 0.08);
      z-index: 100;
      .el-submenu.SmartLink_sub::after {
        content: '';
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #ff9933;
        position: absolute;
        top: 60px;
        left: 120px;
      }
      li.el-menu-item.ym-submenu.Offers:nth-of-type(2)::after {
        content: 'New';
        width: 54px;
        height: 16px;
        background: rgba(255, 153, 51, 0.1);
        border-radius: 4px 4px 4px 0px;
        border: 1px solid rgba(255, 153, 51, 1);
        color: #ff9933;
        position: relative;
        top: -8px;
        left: -2px;
        font-size: 12px;
        padding: 2px;
      }
    }
    .el-card.is-always-shadow,
    .el-card.is-hover-shadow:focus,
    .el-card.is-hover-shadow:hover {
      box-shadow: 0 2px 12px 0px rgba(36, 117, 164, 0.08);
    }
    .el-menu {
      color: #c7cbd2;
      height: 100%;
      .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 192px;
      }
    }
    .ym-submenu {
      padding-left: 51px !important;
      padding-right: 0 !important;
    }
    .ym-submenu.el-menu-item.is-active {
      padding-left: 47px !important;
    }
    .el-menu-item.is-active {
      .menu-item-a {
        color: #1861f2 !important;
      }
    }
    .el-icon-menu {
      margin-left: 16px;
    }
    .ym-menu.el-menu--collapse {
      .ym-sub-text,
      .el-submenu__title .el-submenu__icon-arrow {
        display: none;
      }
      .is-active .el-tooltip {
        padding: 0 16px !important;
      }
    }
    .ym-menu {
      .icon-bangzhu {
        font-size: 18px !important;
        margin-right: 15px !important;
      }
      .my-app-menu.is-active {
        border-left: none !important;
        background: #f0f3fa !important;
        border-radius: 20px !important;
        width: 184px;
        margin: 0 auto;
        padding-left: 6px !important;
        padding-right: 6px !important;
      }
      .my-app-menu {
        border-left: none !important;
        background: #f6f8fb !important;
        border-radius: 20px !important;
        width: 184px;
        padding-left: 6px !important;
        padding-right: 6px !important;
        margin: 0 auto;
        .my-app-menu-img,
        .my-app-menu-img1 {
          width: 30px;
          height: 30px;
          max-width: 30px;
          max-height: 30px;
          margin-right: 8px;
        }
        .my-app-menu-img1 {
          margin-left: -6px;
        }
      }
    }
    .ym-menu:not(.el-menu--collapse) {
      width: 200px;
      min-height: 400px;
    }
    .el-menu--collapse {
      .my-app-menu {
        width: 64px !important;
      }
    }
  }
  .ym-title {
    display: inline-block;
    margin-bottom: 18px;
    font-size: 20px;
    font-weight: 400;
    color: rgba(155, 158, 163, 1);
  }
  .ym-add-title {
    display: inline-block;
    height: 32px;
    font-size: 20px;
    font-weight: 400;
    color: #9b9ea3;
    line-height: 32px;
    margin: 0;
    margin-right: 12px;
  }
  .ym-sub-title {
    line-height: 22px;
    font-size: 14px;
    color: #9b9ea3;
  }
  .add-app-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
    margin-block-start: 1em;
    margin-block-end: 1em;
    width: fit-content;
  }
  .add-app {
    font-size: 48px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .add-icon {
      font-size: 100%;
      color: #1861f2;
      width: 100%;
      height: 100%;
    }
  }
}

.ym-container {
  .pay-list2-action {
    .el-dialog {
      margin-top: 22vh !important;
    }
    .el-dialog__header {
      display: none !important;
    }
    .el-dialog__body {
      padding: 0 !important;
    }
    .pay-list2-body {
      background: url('./assets/img/ganen-pop.png') no-repeat;
      width: 600px; // changePop
      height: 314px; // changePop
      // width: 500px;
      // height: 357px;
      background-size: cover;
      cursor: pointer;
    }
    .pay-list2-icon {
      background: #808080;
      height: 0;
      display: flex;
      justify-content: center;
      .icon-circle-close {
        color: white;
        margin-top: 14px;
        cursor: pointer;
      }
    }
  }
}

.lang-menu{
  top: 64px !important;
  width: 60px;
}

.user-dropdown {
  background: #fff;
  width: 200px;
  top: 64px !important;
  cursor: pointer;
  padding: 12px 0;
  .dropdown-item {
    box-sizing: border-box;
    width: 200px;
    color: #606266;
    padding: 9px 18px;
    font-size: 14px;
    .iconfont {
      color: #d0d3d9;
      font-size: 20px;
      vertical-align: -2px;
    }
    .dropdown-item-text {
      vertical-align: middle;
    }
    &:hover {
      color: #1861f2;
      background: #f5f7fa;
      .iconfont {
        color: #1861f2;
      }
    }
  }
}

.copyright {
  text-align: center;
  > span {
    font-size: 13px;
    color: #c7cbd2;
    cursor: pointer;
    margin-right: 20px;
    &:first-child {
      cursor: inherit;
    }
    &:last-child {
      margin-right: 0;
    }
    &:nth-child(2):hover {
      text-decoration: underline;
    }
    &:last-child:hover {
      text-decoration: underline;
    }
  }
}

.el-tooltip__popper[x-placement^='left'] .popper__arrow::after {
  border-left-color: #1861f2 !important;
}

@media screen and (max-width: 1550px) {
  #elMain {
    .web-divs {
      .web-divs-item {
        height: 230px !important;
        &:nth-child(2) {
          height: 266px !important;
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  #elMain {
    .web-divs {
      flex-direction: column;
      .web-divs-item {
        width: 100% !important;
        margin-bottom: 24px;
        box-sizing: border-box;
        height: max-content !important;
        &:nth-child(2) {
          width: 100% !important;
        }
        &:last-child {
          .tips {
            display: flex;
            flex-direction: column;
          }
        }
      }
    }
  }
}

.register-dialog{
  background-color: rgba(0, 0, 0, 0.6);
}

@media screen and (max-width: 1025px) {
  .ym-container {
    .guide-confirm {
      .el-dialog {
        width: 90% !important;
        .el-dialog__body {
          padding: 20px 14px !important;
          .content {
            flex-wrap: wrap !important;
            .contentItem {
              width: 50% !important;
              > img {
                width: 100% !important;
                height: auto !important;
                max-width: 200px;
              }
              .p1 {
                line-height: inherit !important;
              }
              > p {
                font-size: 12px !important;
              }
            }
          }
        }
        .top {
          margin-bottom: 24px;
          > p {
            font-size: 16px;
            height: auto;
            line-height: 16px;
          }
        }
      }
      .footer {
        .footer-wrap {
          flex-direction: column;
          align-items: flex-start !important;
          .el-button--primary {
            margin-top: 30px;
            width: 100% !important;
          }
          .tip-wap {
            > span {
              font-size: 14px !important;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .back-top {
    right: 14px !important;
  }
  .ym-container {
    .info-wrap {
      width: 340px;
      right: 16px;
      .info-content {
        .content-list {
          width: 100%;
          .list-item {
            .content-btn {
              display: flex !important;
            }
            .content-banner-mobile {
              display: block !important;
              > img {
                width: 100%;
                height: 100%;
              }
            }
            .item-desc {
              -webkit-line-clamp: inherit !important;
            }
          }
        }
        .content-detail {
          display: none;
        }
      }
    }
    .pay-list2-action {
      .pay-list2-body {
        width: 300px !important;
        height: 157px !important; // changePop
        // height: 214px !important;
      }
      .el-dialog {
        width: 300px !important;
      }
    }
  }
  .header-container {
    .follow-web {
      display: none !important;
    }
    .follow-web-mobile {
      display: block !important;
    }
  }
}
@media screen and (max-width: 551px) {
  .ym-container.el-container {
    .ym-header-logo-wrap {
      // min-width: 155px !important;
      min-width: 65px !important;
    }
    .ym-header-logo {
      .ym-btn-collapse {
        font-size: 24px;
      }
      .head-logo {
        width: 114px;
        height: 20px;
      }
      .ym-btn-collapse {
        margin-left: 8px;
      }
      .logo {
        display: none;
      }
      .logo-mini {
        display: none !important;
        // width: 20px !important;
        // height: 20px !important;
      }
      .logo-mini2 {
        display: inline-block !important;
      }
    }
    .header-container {
      .balance {
        margin-right: 12px;
        height: 26px !important;
        max-width: 124px !important;
        .balance-num {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          max-width: 80px;
        }
        .balance-logo {
          width: 20px !important;
          height: 20px !important;
        }
      }
      .info {
        margin-right: 16px;
        .info-logo {
          // width: 20px;
          // height: 20px;
        }
      }
      .header-user {
        line-height: initial;
        .user-logo {
          // width: 20px !important;
          // height: 20px !important;
        }
        .icon-icon_xia1 {
          font-size: 18px !important;
        }
        .el-dropdown-link {
          display: flex;
          align-items: center;
        }
      }
    }
    .add-app {
      font-size: 38px;
    }
  }
  .ym-main {
    .ym-main-aside {
      position: fixed;
      left: 0;
      top: 56px;
      bottom: 0;
    }
    .el-menu--collapse {
      // display: none;
      width: 0 !important;
    }
  }
  .ym-container {
    .info-tip-wrap {
      width: 260px !important;
    }
  }
}

#elMain {
  .web-titles {
    margin: 16px 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    > p {
      &:first-child {
        font-size: 20px;
        color: #303133;
        line-height: 32px;
        font-weight: 600;
        letter-spacing: 1px;
        margin-right: 14px;
        > span {
          color: #1861f2;
        }
      }
      &:last-child {
        font-size: 16px;
        color: #606266;
        line-height: 24px;
      }
    }
  }
  .web-divs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .web-divs-item {
      width: calc(32.5% - 36px);
      background: #ffffff;
      border-radius: 4px;
      padding: 20px 16px 16px 20px;
      height: 220px;
      .top {
        margin-bottom: 16px;
        display: flex;
        justify-content: space-between;
        > span {
          padding-left: 8px;
          border-left: 4px solid #1861f2;
          height: 24px;
          font-weight: 500;
          font-size: 16px;
          color: #606266;
          line-height: 24px;
        }
        > a {
          font-size: 12px;
          color: #909399;
          line-height: 20px;
          padding: 0;
          &:hover {
            text-decoration: underline;
            color: #1861f2;
          }
        }
      }
      .mid {
        .mid-item {
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          .left {
            width: 92px;
            height: 32px;
            background: #1861f2;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            margin-right: 12px;
            cursor: pointer;
          }
          .right {
            font-weight: 400;
            font-size: 14px;
            color: #606266;
            line-height: 20px;
            text-align: left;
          }
        }
      }
      .bottom {
        width: 100%;
        background: #e30077;
        border-radius: 4px;
        font-weight: 600;
        font-size: 16px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        height: 36px;
      }
      .tips {
        > a {
          margin: 0;
          margin-bottom: 8px;
          font-size: 14px;
          color: #606266;
          padding: 0;
          line-height: 20px;
          word-break: break-word;
          display: block;
          &:hover {
            color: #1861f2;
          }
        }
      }
      &:nth-child(2) {
        padding: 0;
        height: 256px;
        .logo {
          width: 100%;
          height: 195px;
        }
        > div > p {
          font-size: 14px;
          color: #606266;
          line-height: 20px;
          margin-bottom: 5px;
        }
        > div {
          padding: 10px 13px 7px;
        }
      }
    }
  }
}
</style>
